import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useTranslation from "../hooks/traslation";
import Loader from "../constants/Loader";

type props = {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  text: string;
  handleSubmit: () => void;
  isLoading?: boolean;
};
export const ConfirmationModal = ({
  openModal,
  setOpenModal,
  text,
  handleSubmit,
  isLoading = false,
}: props) => {
  const transation = useTranslation();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#ffff",
    // border: "1px solid #fff",
    boxShadow: 24,
    p: 6,
    borderRadius: 3,
    outline: "none",
  };
  return (
    <Modal
      open={openModal}
      onClose={isLoading ? undefined : () => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="logout_mdl"
    >
      <Box sx={style}>
        <Loader isLoad={isLoading} />
        <IconButton
          onClick={() => {
            if (!isLoading) setOpenModal(false);
          }}
          disabled={isLoading}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#252525",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ textAlign: "center", fontSize: "20px", color: "#1d2b28" }}
        >
          {text}
        </Typography>
        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "center",
            paddingTop: "20px",
          }}
        >
          <Button
            className="btn btn_primary"
            sx={{ minWidth: "100px" }}
            disabled={isLoading}
            onClick={() => {
              if (!isLoading) {
                handleSubmit();
              }
            }}
          >
            {transation.globals.Yes}
          </Button>

          <Button
            className="btn btn_primary"
            sx={{ minWidth: "100px" }}
            disabled={isLoading}
            onClick={() => {
              if (!isLoading) setOpenModal(false);
            }}
          >
            {transation.globals.No}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
